// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastPlayer-cls1_-23","cls2":"PodcastPlayer-cls2_XNO PodcastPlayer-cls1_-23"};